import {StaticNotificationType} from "./types";
import Routing from "../Routing.ts";
import IconAlert from "../components/icons/IconAlert.tsx";
import IconCreditcard from "../components/icons/IconCreditcard.tsx";
import IconInfo from "../components/icons/IconInfo.tsx";
import IconDocument from "../components/icons/IconDocument.tsx";
import IconRocket from "../components/icons/IconRocket.tsx";


export const staticNotificationMap: {[key: string]: StaticNotificationType} = {
    'sbbu': {
        title: () => <>Skal vi opsige dit gamle internet?</>,
        important: true,
        icon: IconAlert,
        link: Routing.Selfcare.TerminateExisting,
    },
    'card.no-card': {
        title: () => <>Husk at tilføje et betalingskort</>,
        important: true,
        icon: IconCreditcard,
        link: Routing.Selfcare.AddCard
    },
    'card.is-expired': {
        title: () => <>Dit betalingskort er udløbet &ndash; tilføj et nyt her</>,
        important: true,
        icon: IconCreditcard,
        link: Routing.Selfcare.AddCard
    },
    'card.expires-soon': {
        title: () => <>Dit betalingskort udløber snart</>,
        important: true,
        icon: IconCreditcard,
        link: Routing.Selfcare.AddCard
    },
    'invoice.is-processing-payment': {
        title: () => <>Din betaling er i gang.<br/><br/>Det kan tage lidt tid, hvis vi har mange besøgende. Du kan lukke siden, selv om betalingen er i gang.<br /><br />Du får en mail med en status på betalingen.</>,
        important: true,
        icon: IconInfo,
        link: Routing.Selfcare.PayBill,
    },
    'invoice.pay-overdue-invoices': {
        title: (payload) => payload.overdue_count as number > 1 ? `Du har ${payload.overdue_count} udestående regninger, til et samlet beløb på ${payload.overdue_sum} Betal her.` : `Du har en udestående regning på ${payload.overdue_sum} Betal her.`,
        important: true,
        icon: IconAlert,
        link: Routing.Selfcare.PayBill
    },
    'invoice.view-next-invoice': {
        title: () => <>Se din kommende regning</>,
        important: false,
        icon: IconDocument,
        link: Routing.Selfcare.NextBill,
    },
    'invoice.view-latest-paid-invoice': {
        title: () => <>Se din senest betalte regning</>,
        important: false,
        icon: IconDocument,
        link: Routing.Selfcare.Bills
    },
    'invoice.unpaid-invoice-and-credit-available': {
        title: (payload) => `Du har udestående regninger for ${payload.overdue_amount} Du har et tilgodehavende på ${payload.balance} Dette tilgodehavende vil blive modregnet på dine udestående regninger.`,
        important: false,
        icon: IconDocument,
        link: null
    },
    'invoice.credit-available': {
        title: (payload) => `Du har et tilgodehavende på ${payload.balance} Dette tilgodehavende vil blive modregnet på din næste regning.`,
        important: false,
        icon: IconDocument,
        link: null
    },
    'delivery-flow.link': {
        title: () => `Se dit installationsforløb`,
        important: false,
        icon: IconRocket,
        className: 'selfcare-overview-message--highlight',
        link: '#installationsforloeb'
    },
}
